import React, { DetailedHTMLProps, InputHTMLAttributes } from "react";

import classnames from "classnames";
import { CloseIcon } from "../../../icons";
import Button from "../Button";
import { H4 } from "../Typography";

type ModalHeaderProps = {
  /**
   * onClose modal behaviour
   * If undefined no close button will be there and it is up to you to handle when the modal should close
   * @default undefined
   */
  onClose?: () => void;
} & DetailedHTMLProps<
  InputHTMLAttributes<HTMLHeadingElement>,
  HTMLHeadingElement
>;

const ModalHeader = React.forwardRef<HTMLHeadingElement, ModalHeaderProps>(
  ({ className, onClose, children, ...props }, ref) => {
    const headerStyle = classnames(
      className ||
        "px-4 pt-5 sm:px-6 sm:pt-6 flex items-center justify-between"
    );

    return (
      <div className={headerStyle}>
        <H4 {...props} ref={ref}>
          {children}
        </H4>
        {onClose && (
          <Button aria-label='Close modal' icon={CloseIcon} onClick={onClose} variant="ghost" />
        )}
      </div>
    );
  }
);

export default React.memo(ModalHeader);
